// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderPop_container__1b4QG","button":"OrderPop_button__2lZgN","icon":"OrderPop_icon__1YYBU"};